import * as React from 'react';

import { mergeStyles } from '@cian/utils';
import * as styles from './NoPhoto.css';

const image = require('./assets/photos.svg');

export const NoPhoto = ({ className, draggable }: React.HTMLAttributes<HTMLDivElement>): React.JSX.Element => {
  return (
    <img {...mergeStyles(styles['container'], className)} draggable={draggable} src={image} data-testid="NoPhoto" />
  );
};
